module.exports = "input{width:20px;height:20px}\n"